import { Component } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {GlobalsTxt} from './txtGlobals';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'SSO';
  globalsTxt: GlobalsTxt;
  constructor(private httpClient: HttpClient,
              globalsTxt: GlobalsTxt) {
              this.globalsTxt = globalsTxt;
              this.globalsTxt.language =  'es';
              this.httpClient.get(this.globalsTxt.language === 'es' ? 'assets/textos_sso_es.json' :
               'assets/textos_sso_en.json').subscribe(data =>{
                this.globalsTxt.textosSso = data['sso'];
              });
  }


}
